function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "control-bar/videos-and-images",
  transform: "translate(-487.000000, -38.000000)",
  fill: "#5C7284",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Video-play",
  transform: "translate(99.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M390.25,59 C390.859375,59 391.359375,58.78125 392,58.421875 L409.296875,48.40625 C410.546875,47.6875 411,47.171875 411,46.34375 C411,45.515625 410.546875,45 409.296875,44.28125 L392,34.265625 C391.359375,33.90625 390.859375,33.6875 390.25,33.6875 C389.125,33.6875 388.375,34.546875 388.375,35.890625 L388.375,56.796875 C388.375,58.140625 389.125,59 390.25,59 Z",
  id: "next-button"
}))));

function SvgIconNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "26px",
    viewBox: "0 0 23 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "next button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNext);
export default __webpack_public_path__ + "static/media/icon_next.3ce7778d.svg";
export { ForwardRef as ReactComponent };